module.exports = __webpack_public_path__ + "01ea978f/img/archive-icon.0a6a9de3.svg";